<template>
    <div
        class="generic-search"
        :class="{
            open: items && items.length > 0,
            closed: !items || items.length == 0,
        }">
        <div class="value-row">
            <ui5-input
                type="text"
                @change="onValueChange"
                :name="field.datafieldId"
                :id="field.datafieldId"
                :value="field.fieldvalue || ''"
                readonly />
            <div v-if="field.fieldvaluedescription">
                {{ field.fieldvaluedescription || '' }}
            </div>
        </div>
        <div class="filters-row">
            <!-- //generate two fields to filter on based on the data from the db
           //The names of the fields are tableField and tableField2
           //Also use these names as id's for the fields -->
            <ui5-input
                class="changeGeneric"
                :disabled="disabled"
                type="Text"
                :name="field.tableField"
                :id="field.tableField"
                :value="filterValue"
                @change="
                    filterValue = $event.target.value;
                    onFilterChange(field);
                "
                :placeholder="field.tableFieldName" />
            <ui5-input
                class="changeGeneric"
                :disabled="disabled"
                type="text"
                :name="field.tableField2"
                :id="field.tableField2"
                :value="filterValue2"
                @change="
                    filterValue2 = $event.target.value;
                    onFilterChange(field);
                "
                :placeholder="field.tableFieldName2" />
        </div>
        <div class="list-container">
            <div
                class="ui5-list-copy"
                v-if="items"
                :id="'list' + field.datafieldId">
                <div
                    class="ui5-li-copy"
                    v-for="(item, itemIndex) in items"
                    @click="itemSelected(item)"
                    :key="'item.' + itemIndex">
                    {{ item[field.tableField] }} - {{ item[field.tableField2] }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import genericApi from '../../api/generic';
const clearedValues = {
    filterValue: '',
    filterValue2: '',
    items: null,
};
export default {
    props: ['field', 'afterValueChange', 'disabled'],
    data() {
        return { ...clearedValues };
    },
    methods: {
        itemSelected(item) {
            if (!this.disabled) {
                this.field.fieldvalue = item.tableKey;
                this.field.fieldvaluedescription = item[this.field.tableField2];
                Object.assign(this, clearedValues);
            }
        },
        onValueChange($event) {
            this.field.fieldvalue = $event.target.value;
            if (this.afterValueChange) {
                this.afterValueChange(field);
            }
        },
        onFilterChange() {
            const value = this.filterValue;
            const value2 = this.filterValue2;
            if (value.length >= 2 || value2.length >= 2) {
                genericApi
                    .listGeneric(
                        this.field.table,
                        this.field.tableKey,
                        this.field.tableField,
                        this.field.tableField2,
                        value,
                        value2,
                        this.field.tableFilter
                    )
                    .then((response) => {
                        const items = response.data.data;
                        items.forEach((item) => {
                            //TableKey is saved under string 'tableKey' and not under it's value as the fields
                            item.tableKey = item.tableKey.replace(
                                /[|&;$%@"'<>()+,]/g,
                                ''
                            );
                        });
                        this.items = items;
                    });
            }
        },
    },
};
</script>
